import * as React from 'react';
import { Component } from 'react';
import { Link, ThemeConfig } from 'docz';
import styled, { css } from 'react-emotion';
import { MenuHeadings } from './MenuHeadings';
const activeWrapper = css `
  padding-left: 0;

  &:after {
    width: 1px;
  }
`;
const Wrapper = styled('div') `
  position: relative;
  transition: padding 0.2s;
  ${(p) => p.active && activeWrapper};
`;
export const linkStyle = ({ colors, isItem, level }) => css `
  position: relative;
  display: block;
  padding: 4px var(--sidebar-padding) 4px
    calc(var(--sidebar-padding) + ${level * 10}px);
  font-weight: ${level > 0 ? 400 : 500};
  font-size: 18px;
  letter-spacing: -0.02em;
  color: ${colors.sidebarText};
  text-decoration: none;
  transition: color 0.2s;

  &:focus,
  &:hover,
  &:visited {
    color: ${colors.sidebarText};
  }

  &:first-line {
    line-height: 22px;
  }

  &.active:not(.no-highlight) {
    font-weight: bold;

    &:before {
      z-index: 1;
      position: absolute;
      display: block;
      content: '';
      top: 0;
      left: 0;
      width: 0;
      height: 30px;
      background: ${colors.primary};
      transition: width 0.2s;
    }

    &.active:before {
      width: 3px;
    }
  }
`;
const LinkAnchor = styled('a') `
  ${p => linkStyle(p.theme.docz)};
  font-size: 14px;
  ${p => !!p.icon &&
    css `
      padding-right: 44px;
      position: relative;
      &:after {
        content: url(${p.icon});
        position: absolute;
        top: calc(50% - 10px);
        right: 20px;
        height: 16px;
        width: 16px;
        vertical-align: -4px;
      }
    `}
`;
export const getActiveFromClass = (el) => Boolean(el && el.classList.contains('active'));
export class MenuLink extends Component {
    constructor(props) {
        super(props);
        this.state = {
            active: false,
        };
        this.updateActive = (prevActive) => {
            const active = getActiveFromClass(this.$el);
            if (prevActive !== active)
                this.setState({ active });
        };
        this.$el = null;
    }
    componentDidUpdate(prevProps, prevState) {
        this.updateActive(prevState.active);
    }
    componentDidMount() {
        this.updateActive(this.state.active);
    }
    render() {
        const { active } = this.state;
        const { item, children, onClick, innerRef, isItem, level } = this.props;
        const commonProps = (config) => ({
            children,
            onClick,
            className: linkStyle(Object.assign({}, config.themeConfig, { isItem, level })),
            innerRef: (node) => {
                innerRef && innerRef(node);
                this.$el = node;
            },
        });
        return (React.createElement(Wrapper, { active: active, level: level },
            React.createElement(ThemeConfig, null, config => {
                const route = item.route === '/' ? '/' : item.route;
                const props = Object.assign({}, commonProps(config));
                if (item.type === 'external-link') {
                    return React.createElement(LinkAnchor, Object.assign({}, props, { icon: item.icon, href: item.href }));
                }
                if (item.route) {
                    if (location.hash) {
                        props.activeClassName = 'active no-highlight';
                    }
                    return React.createElement(Link, Object.assign({}, props, { to: route }));
                }
                return React.createElement(LinkAnchor, Object.assign({}, props, { href: "#" }));
            }),
            active && item.route && (React.createElement(MenuHeadings, { route: item.route, level: level }))));
    }
}
//# sourceMappingURL=data:application/json;base64,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